/* tslint:disable */
import { enableProdMode, NgModuleRef } from '@angular/core';
import { disableDebugTools } from '@angular/platform-browser';
import { Environment } from './model';

enableProdMode();

export const environment: Environment = {
  production: true,
  url_google: "https://us-central1-plataforma-tsg-desarrollo.cloudfunctions.net/",
  showDevModule: false,
  showConsoleDebug: true,
  // 🔧 Backend URL para Cloud Run configurada
  apiURL: 'https://smartplume-back.tsgenviro.com/api',
  version: '1.3.4 [2025/07/31] - Cloud Run',
  mapBoxApiToken: 'pk.eyJ1IjoidHNnZW52aXJvIiwiYSI6ImNranlvaGJqdzBmdjYydnBoMDJ1NzZkaWoifQ.gUq8kDlm_xF2PRmL4oFuvg',

  /** Angular debug tools in the dev console
   * https://github.com/angular/angular/blob/86405345b781a9dc2438c0fbe3e9409245647019/TOOLS_JS.md
   * @param modRef
   * @return {any}
   */
  decorateModuleRef(modRef: NgModuleRef<any>) {
    disableDebugTools();
    return modRef;
  },
  ENV_PROVIDERS: [

  ]
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts